<template>
  <v-row>
    <!-- <v-col cols="12" class="v-label v-label--active v-label--active--custom textcolor--text ma-0 pa-0">
      {{ label }}
    </v-col> -->
    <v-col cols="8" class="ma-0 pa-0">
      <v-menu
          ref="menu1"
          v-model="menuDataPicker"
          :readonly="readonly"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
              v-model="formattedData"
              :error="hasErrors"
              prepend-icon="event"
              :append-icon="!readonly && value && !menuDataPicker
                ? 'clear'
                : null"
              readonly
              :label="label"
              v-on="on"
              @click:append="clear">
            <template v-if="required" v-slot:prepend-inner>
              <v-icon
                  small
                  left
                  :color="requiredColor">
                *
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            :allowed-dates="checkDate"
            :readonly="readonly"
            no-title
            scrollable
            :locale="controlLocale"
            :first-day-of-week="1"
            :min="minDate"
            :max="maxDate">
          <v-spacer />
          <v-btn
              id="cancelDateBtn"
              text
              color="primary"
              @click.stop="menuDataPicker = false">
            {{ $t('Отмена') }}
          </v-btn>
          <v-btn
              id="selectDateBtn"
              text
              color="primary"
              @click.stop="saveDate">
            {{ $t('Выбрать') }}
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="4" class="ma-0 pa-0">
      <v-menu
          ref="menu2"
          v-model="menuTimePicker"
          :readonly="readonly"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          offset-x
          max-width="290px"
          min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
              v-model="time"
              :error="hasErrors"
              prepend-icon="access_time"
              readonly
              max-width="200px"
              v-on="on" />
        </template>
        <v-time-picker
            v-if="menuTimePicker"
            v-model="time"
            :readonly="readonly"
            :locale="controlLocale"
            format="24hr"
            @click:minute="saveTime" />
      </v-menu>
    </v-col>
    <v-col cols="12" class="red--text text-left">
      <p
          v-for="(err, index) in errorMessages"
          :key="index">
        {{ err }}
      </p>
    </v-col>
  </v-row>
</template>

<style scoped>
 .v-label--active--custom {
   font-size: 12px;
 }
</style>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: String,
      errorMessages: Array,
      minSelectedDate: {
        type: String,
        default: '1991-01-01'
      },
      maxSelectedDate: {
        type: String
      },
      dayOffDates: Array,
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      }
    },
    data () {
      return {
        menuDataPicker: false,
        menuTimePicker: false,
        date: null,
        time: '00:00'
      }
    },
    computed: {
      formattedData () {
        return this.date && this.date !== 'Invalid date'
          ? this.$moment(this.date).format('DD.MM.YYYY')
          : null
      },
      hasErrors () {
        return this.errorMessages && this.errorMessages.length > 0
      },
      minDate () {
        return this.$moment(this.minSelectedDate).format('YYYY-MM-DD')
      },
      maxDate () {
        return this.maxSelectedDate
          ? this.$moment(this.maxSelectedDate).format('YYYY-MM-DD')
          : this.$moment(this.$moment().add(10, 'years')).format('YYYY-MM-DD')
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newValue) {
          if (newValue && newValue !== 'Invalid date') {
            this.initDateTime(newValue)
          }
        }
      }
    },
    methods: {
      checkDate: function (val) {
        return !this.dayOffDates ||
          !this.dayOffDates.length ||
          !this.dayOffDates.includes(val)
      },
      initDateTime: function (value) {
        this.date = this.$moment(value).format('YYYY-MM-DD')
        this.time = this.$moment(value).format('HH:mm')
      },
      saveTime: function () {
        this.$refs.menu2.save(this.time)
        this.updateValue()
      },
      saveDate: function () {
        this.$refs.menu1.save(this.date)
        this.updateValue()
      },
      updateValue: function () {
        if (!this.date || this.date === 'Invalid date') {
          return
        }
        const date = this.time
          ? this.date + ' ' + this.time
          : this.date
        const newDateTime = this.$moment(date).format('YYYY-MM-DDTHH:mm:ss')
        this.$emit('input', newDateTime)
      },
      clear: function () {
        this.date = null
        this.time = '00:00'
        this.$emit('input', null)
      }
    }

  }
</script>
